import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";
import { Identifiable, StrategicAxis } from "@planzone/dto";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editStrategicAxis(request: Boundaries["editStrategicAxis"]["request"]): void;
}

function useEditStrategicAxis(
  strategicAxis: Identifiable<StrategicAxis>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditStrategicAxisRequestPending(strategicAxis),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditStrategicAxisRequestSuccess(strategicAxis),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditStrategicAxisRequestFailure(strategicAxis),
    ),
    editStrategicAxis: core.editStrategicAxis,
  };
}

export { useEditStrategicAxis };
